<template>
  <tr>
    <td>{{ item.Profile.Name }}</td>
    <!-- 以下手機版不顯示 -->
    <td v-show="!isMobile">{{ item.Username }}</td>
    <td v-show="!isMobile">{{ department && department.Name }}</td>
    <td v-show="!isMobile">{{ level }}</td>
    <td v-show="!isMobile">
      <span v-if="position.Level < 10">{{ leftCompensatory/8 }}天</span>
    </td>
    <!-- 以上手機版不顯示 -->
    <td v-if="canEditUser">
      <!-- <v-icon class="ml-1 mr-1" @click.stop="editItem">edit</v-icon> -->
      <v-btn @click.stop="viewItem">檢視</v-btn>
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="confirmResetPassword"
      >重設</v-btn>
      <v-icon
        class="ml-1 mr-1"
        @click.stop="editItem"
      >edit</v-icon>
      <v-icon @click.stop="confirmDeleteItem">delete</v-icon>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import redirectMixin from "@/ui/mixin-redirect.vue";
export default {
  mixins: [redirectMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      isShowDetail: false
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    position() {
      return this.userPositions.find(o => o.UserID == this.item.ID);
    },
    level() {
      if (this.position.Level === 1) return "員工";
      if (this.position.Level === 10) return "主管";
      if (this.position.Level === 100) return "會計";
      if (this.position.Level === 1000) return "總經理";
      if (this.position.Level === 10000) return "蝦董";
      if (this.position.Level === 100000) return "工程師";
      return this.position.Level;
    },
    department() {
      let departmentID = (
        this.userDepartments.find(o => o.UserID == this.item.ID) || {}
      ).DepartmentID;
      if (!departmentID) return null;
      return this.departments.find(o => o.ID == departmentID);
    },
    leftCompensatory() {
      return this.$store.state.compensatoryTime.list.filter(o => o.UserID == this.item.ID).reduce((sum,o)=>sum+((o.Status=='通過' || o.LeaveFormID > 0)?o.Hours : 0), 0)
    },
    ...mapGetters([
      "canEditUser",
      "userPositions",
      "userDepartments",
      "departments"
    ])
  },
  methods: {
    viewItem() {
      this.redirectToUser(this.item.ID);
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmResetPassword() {
      if (!confirm("確定重設「" + (this.item.Profile.Name || "") + "」的密碼?"))
        return;
      this.$emit("reset", this.item);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Profile.Name || "") + "」?"))
        return;
      this.$emit("remove", this.item);
    }
  }
};
</script>